import { ACTIONS, CDN77_STATUS } from '../const.config';

// HLS transcoder module configurations
export const LISTING_COLUMNS = [
  {
    id: 'jobId',
    label: 'Job ID',
    align: 'center',
    dataKey: 'jobId',
    sortable: true,
  },
  {
    id: 'filePath',
    label: 'Video Name',
    align: 'left',
    dataKey: 'filePath',
    sortable: true,
  },
  {
    id: 'sourcePath',
    label: 'Source Path',
    align: 'left',
    dataKey: 'sourcePath',
    sortable: false,
  },
  {
    id: 'destinationPath',
    label: 'Destination Path',
    align: 'left',
    dataKey: 'destinationPath',
    sortable: false,
  },
  {
    id: 'resolution',
    label: 'Src Quality',
    align: 'center',
    dataKey: 'resolution',
    sortable: true,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'center',
    dataKey: 'status',
    sortable: true,
  },
  {
    id: 'modifiedAt',
    label: 'Date',
    align: 'right',
    dataKey: 'modifiedAt',
    sortable: true,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.CHECK_STATUS.value,
    label: ACTIONS.CHECK_STATUS.label,
    conditional: (data) =>
      data.status === CDN77_STATUS.PENDING ||
      data.status === CDN77_STATUS.PREPROCESSING ||
      data.status === CDN77_STATUS.RUNNING ||
      data.status === CDN77_STATUS.POSTPROCESSING,
  },
  {
    action: ACTIONS.CANCEL_JOB.value,
    label: ACTIONS.CANCEL_JOB.label,
    conditional: (data) =>
      data.status === CDN77_STATUS.PENDING ||
      data.status === CDN77_STATUS.PREPROCESSING ||
      data.status === CDN77_STATUS.RUNNING ||
      data.status === CDN77_STATUS.POSTPROCESSING,
  },
  {
    action: ACTIONS.PROCESS_AGAIN.value,
    label: ACTIONS.PROCESS_AGAIN.label,
    conditional: (data) =>
      data.status === CDN77_STATUS.COMPLETE ||
      data.status === CDN77_STATUS.CANCELLED ||
      data.status === CDN77_STATUS.FAILED ||
      data.status === CDN77_STATUS.ERROR,
  },
  {
    action: ACTIONS.COPY_URL.value,
    label: ACTIONS.COPY_URL.label,
    conditional: (data) => data.status === CDN77_STATUS.COMPLETE,
  },
];
